module.exports = __webpack_public_path__ + "static/media/01-cht.beae4ce4.png";